var map = {
	"./Access/Roles": [
		7770,
		391,
		7770
	],
	"./Access/Roles/": [
		7770,
		391,
		7770
	],
	"./Access/Roles/Column": [
		5050,
		5050
	],
	"./Access/Roles/Column.tsx": [
		5050,
		5050
	],
	"./Access/Roles/index": [
		7770,
		391,
		7770
	],
	"./Access/Roles/index.tsx": [
		7770,
		391,
		7770
	],
	"./Access/Roles/permission": [
		9857,
		9857
	],
	"./Access/Roles/permission.tsx": [
		9857,
		9857
	],
	"./Access/Users": [
		4585,
		4585
	],
	"./Access/Users/": [
		4585,
		4585
	],
	"./Access/Users/AssignRoleForm": [
		1085,
		1085
	],
	"./Access/Users/AssignRoleForm/": [
		1085,
		1085
	],
	"./Access/Users/AssignRoleForm/index": [
		1085,
		1085
	],
	"./Access/Users/AssignRoleForm/index.tsx": [
		1085,
		1085
	],
	"./Access/Users/Column": [
		4027,
		6408
	],
	"./Access/Users/Column.tsx": [
		4027,
		6408
	],
	"./Access/Users/Form": [
		4526,
		4526
	],
	"./Access/Users/Form/": [
		4526,
		4526
	],
	"./Access/Users/Form/index": [
		4526,
		4526
	],
	"./Access/Users/Form/index.tsx": [
		4526,
		4526
	],
	"./Access/Users/index": [
		4585,
		4585
	],
	"./Access/Users/index.tsx": [
		4585,
		4585
	],
	"./Assigned-Papers": [
		830,
		830
	],
	"./Assigned-Papers/": [
		830,
		830
	],
	"./Assigned-Papers/Column": [
		290,
		290
	],
	"./Assigned-Papers/Column.tsx": [
		290,
		290
	],
	"./Assigned-Papers/index": [
		830,
		830
	],
	"./Assigned-Papers/index.tsx": [
		830,
		830
	],
	"./Branches": [
		9330,
		9330
	],
	"./Branches/": [
		9330,
		9330
	],
	"./Branches/Column": [
		6350,
		6350
	],
	"./Branches/Column.tsx": [
		6350,
		6350
	],
	"./Branches/Form": [
		5059,
		5059
	],
	"./Branches/Form/": [
		5059,
		5059
	],
	"./Branches/Form/index": [
		5059,
		5059
	],
	"./Branches/Form/index.tsx": [
		5059,
		5059
	],
	"./Branches/View": [
		9569,
		9569
	],
	"./Branches/View/": [
		9569,
		9569
	],
	"./Branches/View/index": [
		9569,
		9569
	],
	"./Branches/View/index.tsx": [
		9569,
		9569
	],
	"./Branches/index": [
		9330,
		9330
	],
	"./Branches/index.tsx": [
		9330,
		9330
	],
	"./Customer-Query": [
		6211,
		3141,
		6211
	],
	"./Customer-Query/": [
		6211,
		3141,
		6211
	],
	"./Customer-Query/ActivityLog": [
		9547,
		9547
	],
	"./Customer-Query/ActivityLog/": [
		9547,
		9547
	],
	"./Customer-Query/ActivityLog/index": [
		9547,
		9547
	],
	"./Customer-Query/ActivityLog/index.tsx": [
		9547,
		9547
	],
	"./Customer-Query/ActivityLogByWeekly": [
		3589,
		3589
	],
	"./Customer-Query/ActivityLogByWeekly/": [
		3589,
		3589
	],
	"./Customer-Query/ActivityLogByWeekly/index": [
		3589,
		3589
	],
	"./Customer-Query/ActivityLogByWeekly/index.tsx": [
		3589,
		3589
	],
	"./Customer-Query/index": [
		6211,
		3141,
		6211
	],
	"./Customer-Query/index.tsx": [
		6211,
		3141,
		6211
	],
	"./Customer-Query/table": [
		329,
		329
	],
	"./Customer-Query/table.tsx": [
		329,
		329
	],
	"./Customer/Additional-Paper": [
		7919,
		7919
	],
	"./Customer/Additional-Paper/": [
		7919,
		7919
	],
	"./Customer/Additional-Paper/Column": [
		5329,
		5329
	],
	"./Customer/Additional-Paper/Column.tsx": [
		5329,
		5329
	],
	"./Customer/Additional-Paper/Form": [
		7152,
		7152
	],
	"./Customer/Additional-Paper/Form/": [
		7152,
		7152
	],
	"./Customer/Additional-Paper/Form/index": [
		7152,
		7152
	],
	"./Customer/Additional-Paper/Form/index.tsx": [
		7152,
		7152
	],
	"./Customer/Additional-Paper/index": [
		7919,
		7919
	],
	"./Customer/Additional-Paper/index.tsx": [
		7919,
		7919
	],
	"./Customer/Details": [
		2025,
		3141,
		2300,
		2365,
		2025
	],
	"./Customer/Details/": [
		2025,
		3141,
		2300,
		2365,
		2025
	],
	"./Customer/Details/AdditionalPapersInfo": [
		4446,
		4446
	],
	"./Customer/Details/AdditionalPapersInfo/": [
		4446,
		4446
	],
	"./Customer/Details/AdditionalPapersInfo/index": [
		4446,
		4446
	],
	"./Customer/Details/AdditionalPapersInfo/index.tsx": [
		4446,
		4446
	],
	"./Customer/Details/BillInfo": [
		56,
		4027
	],
	"./Customer/Details/BillInfo/": [
		56,
		4027
	],
	"./Customer/Details/BillInfo/index": [
		56,
		4027
	],
	"./Customer/Details/BillInfo/index.tsx": [
		56,
		4027
	],
	"./Customer/Details/Form/PaymentForm": [
		3614,
		3614
	],
	"./Customer/Details/Form/PaymentForm.tsx": [
		3614,
		3614
	],
	"./Customer/Details/HolidaysInfo": [
		3605,
		3605
	],
	"./Customer/Details/HolidaysInfo/": [
		3605,
		3605
	],
	"./Customer/Details/HolidaysInfo/index": [
		3605,
		3605
	],
	"./Customer/Details/HolidaysInfo/index.tsx": [
		3605,
		3605
	],
	"./Customer/Details/PapersInfo": [
		6685,
		6685
	],
	"./Customer/Details/PapersInfo/": [
		6685,
		6685
	],
	"./Customer/Details/PapersInfo/index": [
		6685,
		6685
	],
	"./Customer/Details/PapersInfo/index.tsx": [
		6685,
		6685
	],
	"./Customer/Details/PaymentsInfo": [
		2365,
		3141,
		2365
	],
	"./Customer/Details/PaymentsInfo/": [
		2365,
		3141,
		2365
	],
	"./Customer/Details/PaymentsInfo/DailyLogs": [
		9206,
		9206
	],
	"./Customer/Details/PaymentsInfo/DailyLogs/": [
		9206,
		9206
	],
	"./Customer/Details/PaymentsInfo/DailyLogs/index": [
		9206,
		9206
	],
	"./Customer/Details/PaymentsInfo/DailyLogs/index.tsx": [
		9206,
		9206
	],
	"./Customer/Details/PaymentsInfo/PaymentBill": [
		7629,
		7629
	],
	"./Customer/Details/PaymentsInfo/PaymentBill/": [
		7629,
		7629
	],
	"./Customer/Details/PaymentsInfo/PaymentBill/index": [
		7629,
		7629
	],
	"./Customer/Details/PaymentsInfo/PaymentBill/index.tsx": [
		7629,
		7629
	],
	"./Customer/Details/PaymentsInfo/WeeklyLogs": [
		3948,
		3948
	],
	"./Customer/Details/PaymentsInfo/WeeklyLogs/": [
		3948,
		3948
	],
	"./Customer/Details/PaymentsInfo/WeeklyLogs/index": [
		3948,
		3948
	],
	"./Customer/Details/PaymentsInfo/WeeklyLogs/index.tsx": [
		3948,
		3948
	],
	"./Customer/Details/PaymentsInfo/index": [
		2365,
		3141,
		2365
	],
	"./Customer/Details/PaymentsInfo/index.tsx": [
		2365,
		3141,
		2365
	],
	"./Customer/Details/PersonalInfo": [
		1513,
		1513
	],
	"./Customer/Details/PersonalInfo/": [
		1513,
		1513
	],
	"./Customer/Details/PersonalInfo/index": [
		1513,
		1513
	],
	"./Customer/Details/PersonalInfo/index.tsx": [
		1513,
		1513
	],
	"./Customer/Details/VouchersInfo": [
		2300,
		2300
	],
	"./Customer/Details/VouchersInfo/": [
		2300,
		2300
	],
	"./Customer/Details/VouchersInfo/index": [
		2300,
		2300
	],
	"./Customer/Details/VouchersInfo/index.tsx": [
		2300,
		2300
	],
	"./Customer/Details/index": [
		2025,
		3141,
		2300,
		2365,
		2025
	],
	"./Customer/Details/index.tsx": [
		2025,
		3141,
		2300,
		2365,
		2025
	],
	"./Customer/Holidays": [
		7022,
		7022
	],
	"./Customer/Holidays/": [
		7022,
		7022
	],
	"./Customer/Holidays/Column": [
		8834,
		8834
	],
	"./Customer/Holidays/Column.tsx": [
		8834,
		8834
	],
	"./Customer/Holidays/Form": [
		1351,
		1351
	],
	"./Customer/Holidays/Form/": [
		1351,
		1351
	],
	"./Customer/Holidays/Form/index": [
		1351,
		1351
	],
	"./Customer/Holidays/Form/index.tsx": [
		1351,
		1351
	],
	"./Customer/Holidays/index": [
		7022,
		7022
	],
	"./Customer/Holidays/index.tsx": [
		7022,
		7022
	],
	"./Customer/Papers": [
		3480,
		3480
	],
	"./Customer/Papers/": [
		3480,
		3480
	],
	"./Customer/Papers/Column": [
		568,
		568
	],
	"./Customer/Papers/Column.tsx": [
		568,
		568
	],
	"./Customer/Papers/Form": [
		7261,
		7261
	],
	"./Customer/Papers/Form/": [
		7261,
		7261
	],
	"./Customer/Papers/Form/index": [
		7261,
		7261
	],
	"./Customer/Papers/Form/index.tsx": [
		7261,
		7261
	],
	"./Customer/Papers/index": [
		3480,
		3480
	],
	"./Customer/Papers/index.tsx": [
		3480,
		3480
	],
	"./Customer/Payments": [
		1136,
		1136
	],
	"./Customer/Payments/": [
		1136,
		1136
	],
	"./Customer/Payments/Column": [
		3392,
		3392
	],
	"./Customer/Payments/Column.tsx": [
		3392,
		3392
	],
	"./Customer/Payments/index": [
		1136,
		1136
	],
	"./Customer/Payments/index.tsx": [
		1136,
		1136
	],
	"./Customer/Vouchers": [
		3448,
		3448
	],
	"./Customer/Vouchers/": [
		3448,
		3448
	],
	"./Customer/Vouchers/Column": [
		1000,
		1000
	],
	"./Customer/Vouchers/Column.tsx": [
		1000,
		1000
	],
	"./Customer/Vouchers/Form": [
		8557,
		8557
	],
	"./Customer/Vouchers/Form/": [
		8557,
		8557
	],
	"./Customer/Vouchers/Form/index": [
		8557,
		8557
	],
	"./Customer/Vouchers/Form/index.tsx": [
		8557,
		8557
	],
	"./Customer/Vouchers/index": [
		3448,
		3448
	],
	"./Customer/Vouchers/index.tsx": [
		3448,
		3448
	],
	"./Customers": [
		2621,
		2621
	],
	"./Customers/": [
		2621,
		2621
	],
	"./Customers/Column": [
		6163,
		6163
	],
	"./Customers/Column.tsx": [
		6163,
		6163
	],
	"./Customers/Form": [
		6970,
		6970
	],
	"./Customers/Form/": [
		6970,
		6970
	],
	"./Customers/Form/index": [
		6970,
		6970
	],
	"./Customers/Form/index.tsx": [
		6970,
		6970
	],
	"./Customers/index": [
		2621,
		2621
	],
	"./Customers/index.tsx": [
		2621,
		2621
	],
	"./Dashboard": [
		6758,
		3141,
		6758
	],
	"./Dashboard/": [
		6758,
		3141,
		6758
	],
	"./Dashboard/PapersList": [
		7293,
		7293
	],
	"./Dashboard/PapersList.tsx": [
		7293,
		7293
	],
	"./Dashboard/index": [
		6758,
		3141,
		6758
	],
	"./Dashboard/index.tsx": [
		6758,
		3141,
		6758
	],
	"./Dashboard/roundPrint": [
		8661,
		8661
	],
	"./Dashboard/roundPrint.tsx": [
		8661,
		8661
	],
	"./Dashboard/roundTable": [
		736,
		3141,
		736
	],
	"./Dashboard/roundTable.tsx": [
		736,
		3141,
		736
	],
	"./Delivery-Fees": [
		5020,
		5020
	],
	"./Delivery-Fees/": [
		5020,
		5020
	],
	"./Delivery-Fees/Column": [
		2740,
		2740
	],
	"./Delivery-Fees/Column.tsx": [
		2740,
		2740
	],
	"./Delivery-Fees/Form": [
		5385,
		5385
	],
	"./Delivery-Fees/Form/": [
		5385,
		5385
	],
	"./Delivery-Fees/Form/index": [
		5385,
		5385
	],
	"./Delivery-Fees/Form/index.tsx": [
		5385,
		5385
	],
	"./Delivery-Fees/index": [
		5020,
		5020
	],
	"./Delivery-Fees/index.tsx": [
		5020,
		5020
	],
	"./ErrorBoundary": [
		1043
	],
	"./ErrorBoundary/": [
		1043
	],
	"./ErrorBoundary/index": [
		1043
	],
	"./ErrorBoundary/index.tsx": [
		1043
	],
	"./Login": [
		3689,
		3689
	],
	"./Login/": [
		3689,
		3689
	],
	"./Login/index": [
		3689,
		3689
	],
	"./Login/index.tsx": [
		3689,
		3689
	],
	"./NotFound": [
		7430,
		7430
	],
	"./NotFound/": [
		7430,
		7430
	],
	"./NotFound/index": [
		7430,
		7430
	],
	"./NotFound/index.tsx": [
		7430,
		7430
	],
	"./Paper-Query": [
		595,
		3141,
		2458,
		5617
	],
	"./Paper-Query/": [
		595,
		3141,
		2458,
		5617
	],
	"./Paper-Query/Print": [
		6595,
		3141,
		2458,
		5617
	],
	"./Paper-Query/Print/": [
		6595,
		3141,
		2458,
		5617
	],
	"./Paper-Query/Print/index": [
		6595,
		3141,
		2458,
		5617
	],
	"./Paper-Query/Print/index.tsx": [
		6595,
		3141,
		2458,
		5617
	],
	"./Paper-Query/index": [
		595,
		3141,
		2458,
		5617
	],
	"./Paper-Query/index.tsx": [
		595,
		3141,
		2458,
		5617
	],
	"./Paper-Query/table": [
		3339,
		3339
	],
	"./Paper-Query/table.tsx": [
		3339,
		3339
	],
	"./Papers": [
		5019,
		5019
	],
	"./Papers/": [
		5019,
		5019
	],
	"./Papers/Column": [
		9717,
		9717
	],
	"./Papers/Column.tsx": [
		9717,
		9717
	],
	"./Papers/Form": [
		7508,
		7508
	],
	"./Papers/Form/": [
		7508,
		7508
	],
	"./Papers/Form/index": [
		7508,
		7508
	],
	"./Papers/Form/index.tsx": [
		7508,
		7508
	],
	"./Papers/index": [
		5019,
		5019
	],
	"./Papers/index.tsx": [
		5019,
		5019
	],
	"./Payments": [
		327,
		327
	],
	"./Payments/": [
		327,
		327
	],
	"./Payments/Column": [
		1545,
		1545
	],
	"./Payments/Column.tsx": [
		1545,
		1545
	],
	"./Payments/index": [
		327,
		327
	],
	"./Payments/index.tsx": [
		327,
		327
	],
	"./Round": [
		8974,
		8974
	],
	"./Round/": [
		8974,
		8974
	],
	"./Round/Column": [
		7890,
		7890
	],
	"./Round/Column.tsx": [
		7890,
		7890
	],
	"./Round/Form": [
		9655,
		9655
	],
	"./Round/Form/": [
		9655,
		9655
	],
	"./Round/Form/index": [
		9655,
		9655
	],
	"./Round/Form/index.tsx": [
		9655,
		9655
	],
	"./Round/index": [
		8974,
		8974
	],
	"./Round/index.tsx": [
		8974,
		8974
	],
	"./UnAuthorized": [
		3996,
		3996
	],
	"./UnAuthorized/": [
		3996,
		3996
	],
	"./UnAuthorized/index": [
		3996,
		3996
	],
	"./UnAuthorized/index.tsx": [
		3996,
		3996
	],
	"./Vouchers": [
		3631,
		3631
	],
	"./Vouchers/": [
		3631,
		3631
	],
	"./Vouchers/Column": [
		1937,
		1937
	],
	"./Vouchers/Column.tsx": [
		1937,
		1937
	],
	"./Vouchers/Form": [
		7360,
		7360
	],
	"./Vouchers/Form/": [
		7360,
		7360
	],
	"./Vouchers/Form/index": [
		7360,
		7360
	],
	"./Vouchers/Form/index.tsx": [
		7360,
		7360
	],
	"./Vouchers/index": [
		3631,
		3631
	],
	"./Vouchers/index.tsx": [
		3631,
		3631
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 629;
module.exports = webpackAsyncContext;